import { type IButtonStyles, type IContextualMenuItem } from '@fluentui/react';
import {
  Button,
  buttonStylesSplitPrimary,
  buttonStylesSplitSecondary,
  IButtonContainerStyles,
  IconName,
  loaderStylesSpinnerButtonPrimary,
  loaderStylesSpinnerButtonSecondary,
} from '@h2oai/ui-kit';

const buttonStyles: Partial<IButtonStyles> = {
  menuIcon: { margin: 0 },
  root: { width: 140 },
  splitButtonDivider: { right: 38 },
  splitButtonMenuButton: { width: 38 },
};

const buttonContainerStyles: Partial<IButtonContainerStyles> = {
  loaderContainer: {
    bottom: 0,
    right: 40,
    width: `unset`,
    '.ms-Spinner': {
      right: 0,
      width: `unset`,
    },
  },
};

export type ButtonStartPauseCommonProps = {
  menuItems: IContextualMenuItem[];
  text?: string;
  onClick?: () => void;
  primaryDisabled?: boolean;
};

export const ButtonFailed = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      iconName="Sync"
      menuItems={props.menuItems}
      onClick={props.onClick}
      primaryDisabled={props.primaryDisabled}
      split={true}
      styles={[buttonStyles]}
      text={props.text || `Retry`}
    />
  );
};

export const ButtonPaused = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      iconName={IconName.MSNVideos}
      menuItems={props.menuItems}
      onClick={props.onClick}
      primaryDisabled={props.primaryDisabled}
      split={true}
      styles={[buttonStylesSplitPrimary, buttonStyles]}
      text={props.text || `Resume`}
    />
  );
};

export const ButtonPausing = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      buttonContainerStyles={buttonContainerStyles}
      loaderProps={{
        label: props.text || `Pausing`,
        styles: loaderStylesSpinnerButtonSecondary,
      }}
      loading={true}
      menuItems={props.menuItems}
      menuIconName={IconName.ChevronDown}
      onClick={() => {}} // the loader overlays the button, but without the `onClick` the button renders wrongly
      // the loader overlays the primary button, therefor we don't pass down the primaryDisabled prop
      split
      styles={[buttonStylesSplitSecondary, buttonStyles]}
    />
  );
};

export const ButtonReady = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      iconName={IconName.Pause}
      menuItems={props.menuItems}
      onClick={props.onClick}
      primaryDisabled={props.primaryDisabled}
      split={true}
      styles={[buttonStyles]}
      text={props.text || `Pause`}
    />
  );
};

export const ButtonStarting = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      buttonContainerStyles={buttonContainerStyles}
      loaderProps={{
        label: props.text || `Starting`,
        styles: loaderStylesSpinnerButtonPrimary,
      }}
      loading={true}
      menuItems={props.menuItems}
      onClick={() => {}} // the loader overlays the button, but without the `onClick` the button renders wrongly
      // the loader overlays the primary button, therefor we don't pass down the primaryDisabled prop
      split
      styles={[buttonStylesSplitPrimary, buttonStyles]}
    />
  );
};

export const ButtonTerminated = (props: ButtonStartPauseCommonProps) => {
  return (
    <Button
      iconName={IconName.Cancel}
      menuItems={props.menuItems}
      onClick={props.onClick}
      primaryDisabled={props.primaryDisabled}
      split={true}
      styles={[buttonStylesSplitSecondary, buttonStyles]}
      text={props.text || `Terminated`}
    />
  );
};
